import { GoogleSheetCredentialForm } from "../forms/GoogleSheet"
import { CredentialMethod } from "@/constants/credentials/credential"
import { LoginMethod, CredentialDetailsResponseData } from "@/types/credentials"
import { AppName } from "@/constants/application/application"
import { DynamicCredentialForm } from "../forms"

export const getRespectiveForm = (
  appName: AppName,
  appId: string,
  loginMethods: LoginMethod[],
  method: CredentialMethod,
  isFormModal: boolean,
  credentialDetails?: CredentialDetailsResponseData,
) => {
  const props = getCommonProps(appId, loginMethods, method, isFormModal, credentialDetails)
  switch (appName) {
    // TODO remove this when we get solution for oAuth
    case AppName.GOOGLE_SHEET:
      return <GoogleSheetCredentialForm {...props} />
    default:
      return <DynamicCredentialForm {...props} />
  }
}

export const getCommonProps = (
  appId: string,
  loginMethods: LoginMethod[],
  method: CredentialMethod,
  isFormModal: boolean,
  credentialDetails?: CredentialDetailsResponseData
) => ({
  method,
  loginMethods,
  appId,
  isFormModal,
  credentialDetails
})
